import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconDownloadProps extends SVGProps<any> {}
export class SVGIconDownload extends Component<SVGIconDownloadProps> {
  render() {
    const { width = 24, height = 24, color, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-arrow-down"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 471.2 471.2`}
        fill={color}
        {...rest}
      >
        <g>
          <g>
            <path
              d="M457.7,230.15c-7.5,0-13.5,6-13.5,13.5v122.8c0,33.4-27.2,60.5-60.5,60.5H87.5c-33.4,0-60.5-27.2-60.5-60.5v-124.8
			c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v124.8c0,48.3,39.3,87.5,87.5,87.5h296.2c48.3,0,87.5-39.3,87.5-87.5v-122.8
			C471.2,236.25,465.2,230.15,457.7,230.15z"
            />
            <path
              d="M226.1,346.75c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.8-85.8c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0l-62.7,62.8
			V30.75c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v273.9l-62.8-62.8c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1
			L226.1,346.75z"
            />
          </g>
        </g>
      </SVG>
    );
  }
}
